























































































import { Component, Vue } from 'vue-property-decorator'
import {
  BContainer,
  BCardBody,
  BCardTitle,
  BCardText,
  BCard,
  BCol,
  BRow,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup, BFormInput, BInputGroup, BInputGroupAppend
} from 'bootstrap-vue'
import { required, email } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { userRoleOptions } from '@/models/User'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VSelect from 'vue-select'
import { UserRoleEnums } from '@/enums/User'

@Component({
  name: 'AdminAddUser',
  components: {
    BCard,
    BCardBody,
    BCardText,
    BCardTitle,
    BContainer,
    BRow,
    BCol,
    BButton,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,

    VSelect,

    ValidationProvider,
    ValidationObserver
  }

})
export default class AdminAddUser extends Vue {
  private userEmail:string=''
  private userRole:string= UserRoleEnums.Customer
  private userRoleOptions = userRoleOptions()
  $refs!: { addUserRules }
  private mounted () {
    const rules = [email, required]
  }

  private validationForm () {
    this.$refs.addUserRules.validate().then(success => {
      // TODO call invite user to a role

      if (success) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'This is for UI purpose only.',
            icon: 'EditIcon',
            variant: 'success'
          }
        })
      }
    })
  }
}
